import React from "react";

interface IProps {
  vertical?: boolean;
}

const EADivider: React.FC<IProps> = ({ vertical = false }) => {
  return <div className={`divider ${vertical ? "divider-vertical" : ""}`} />;
};

export default EADivider;
